var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"logo",style:({fontSize: _vm.size+'px'})},[_vm._v("XProfit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }